import { gql } from "@apollo/client";

export const GET_USER_PROJECTS = gql`
    query GetUserProjects {
        getUserProjects {
            companySysId
            companyName
            id
            name
            projectId
            actions
            userInputs
            outputs
        }
    }
`;
